// extracted by mini-css-extract-plugin
export var attachment = "_rs-a";
export var emailContainer = "_rs-4";
export var emailContentPaddedContainer = "_rs-b";
export var emailHeader = "_rs-6";
export var emailIframe = "_rs-3";
export var emailInfoIcon = "_rs-9";
export var emailShortenedSummary = "_rs-e";
export var infoDropdown = "_rs-0";
export var infoRowBoundedContent = "_rs-d";
export var internal = "_rs-5";
export var merchant = "_rs-8";
export var messageInputContainer = "_rs-h";
export var normal = "_rs-7";
export var replyCard = "_rs-f";
export var subtleButton = "_rs-1";
export var subtleButtonIconContainer = "_rs-2";
export var toggleViewRepliesButton = "_rs-c";
export var wrappingText = "_rs-g";